/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "dashboard/hr-management/components/Navbars/AdminNavbar.js";
import AdminFooter from "dashboard/hr-management/components/Footers/AdminFooter.js";
import Sidebar from "dashboard/hr-management/components/Sidebar/Sidebar.js";

import routes, { routes_project, routes_hr } from "../../../routes";

const flattenRoutes = (routes) => {
  return routes.reduce((acc, route) => {
    if (Array.isArray(route.routes)) {
      acc.push(...flattenRoutes(route.routes));
    } else {
      acc.push(route);
    }
    return acc;
  }, []);
};

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  useEffect(() => {
    const tailwind = document.getElementById("tailwindcss");
    if (tailwind) tailwind.remove();
    const tailwindDemo = document.getElementById("tailwindcss-demo");
    if (tailwindDemo) tailwindDemo.remove();
  }, []);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes_hr) => {
    return routes_hr.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes_hr.length; i++) {
      if (
        props?.location?.pathname.indexOf(routes_hr[i].layout + routes_hr[i].path) !==
        -1
      ) {
        return routes_hr[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes_hr}
        logo={{
          innerLink: "/hr-admin/hr-management/dashboard3",
          imgSrc: require("../assets/img/brand/AECearth.jpeg"),
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />
        <Routes>
          {getRoutes(flattenRoutes(routes_hr))}
          <Route path="*" element={<Navigate to="/hr-admin/hr-management/dashboard3" replace />} />
        </Routes>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Admin;
